import Ellipse from '~components/svgs/Ellipse';
import styled, { keyframes, css } from 'styled-components';
import { StyledLoadingProps } from './types';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Loading = styled(Ellipse).attrs({
  role: 'progressbar',
})<StyledLoadingProps>`
  animation: ${rotate} 1s linear infinite;
  ${({ $withBackground }) =>
    $withBackground &&
    css`
      background: white;
    `}
`;
